import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/apiKey/importer/apiKeyImporterActions';

export default importerReducers(actions);
